import React from "react";

import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import Style from "../../../../dashboard/Styles/modalStyle.module.css";
import { FormatDateTimeV2 } from "../../../../../utils/functions/ResourceFunctions";



// ... (other imports)

const TimelinePhases = ({ decisions }) => {
  return (
    <div className={Style.timeline_container}>
      <div className={Style.timeline}>
        <div className={Style.timeline_item}>
          <div className={Style.timeline_content}>
            <div className={Style.timeline_circle}></div>
            <div className={Style.timeline_line}></div>
            <p>Start</p>
          </div>
        </div>

        {decisions && decisions.length > 0 && (
          decisions.map((decision, index) => (
            <div key={index} className={Style.timeline_item}>
              <div className={Style.timeline_content}>
                <div className={Style.timeline_circle}></div>
                <div className={Style.timeline_line}></div>
                <p className={Style.stage_title}>{decision.registrationStateDesc}</p>
                <p className={DashboardStyle.labels_group}>
                  User: <span>{decision.initiatorName}</span>
                </p>
                <p className={DashboardStyle.labels_group}>
                  Time: <span>{FormatDateTimeV2(decision.createdAt)}</span>
                </p>
              </div>
            </div>
          ))
        )}

        <div className={Style.timeline_item}>
          <div className={Style.timeline_content}>
            <div className={Style.timeline_circle}></div>
            <div className={Style.timeline_line}></div>
            <p>End</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelinePhases;
